export const CHECK_LOGIN = 'check_login';
export const LOGIN_USER_SUCCESSFUL = 'login_user_successfull';
export const API_ERROR = 'api_failed';
export const RESET_LOGIN_ALERT = "reset_login_alert";
